'use memo';

import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import { TaskModalPageProps } from '../TaskModalPageProps';
import QldAgreementCommissionPage from './QldAgreementCommissionPage';
import NswAgreementCommissionPage from './NswAgreementCommissionPage';

const AgreementCommissionPage = (props: TaskModalPageProps) => {
  switch (props.campaign.state) {
    case CampaignDetailModelState.QLD:
      return <QldAgreementCommissionPage {...props} />;
    case CampaignDetailModelState.NSW:
      return <NswAgreementCommissionPage {...props} />;
    default:
      return null;
  }
};

export default AgreementCommissionPage;
